import MuralAPI from '@/api/mural'

export default {
  clear({ commit }) {
    commit('SET_AVISOS', [])
  },
  fetchAvisos({ commit }, params) {
    return new Promise((resolve, reject) => {
      MuralAPI.listMural(params.pagina)
        .then(response => {
          commit('ADD_AVISOS', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
